module.exports = __webpack_public_path__ + "static/media/call-icon.d9fa9ff2.webp";